
import { GxTabPanel } from '@garpix/garpix-web-components-react';
import { FormikProps } from 'formik';
import cn from 'classnames';
import React, { FC } from 'react';
import 'react-responsive-modal/styles.css';
import Input from '../../../../../components/Input';
import { MODAL_USER_PANELS } from '../../../../../const';
import styles from '../styles/index.module.scss';
import { IInitialValues } from '../types';
import InputNumbers from '../../../../../components/InputNumbers';

interface IAdressPanel {
    formik: FormikProps<IInitialValues>
}

const AddressPanel: FC<IAdressPanel> = ({ formik }) => {
    const { values, handleChange } = formik

    return (
        <GxTabPanel name={MODAL_USER_PANELS.address}>
            <div className={styles['user']}>
                <div className={styles['user--container']}>
                    <Input
                        name='address.country'
                        handleChange={handleChange}
                        label='Страна:'
                        className={styles['item']}
                        value={values.address.country}
                    />
                    <Input
                        name='address.region'
                        handleChange={handleChange}
                        label='Область:'
                        className={styles['item']}
                        value={values.address.region}
                    />
                    <Input
                        name='address.district'
                        handleChange={handleChange}
                        label='Район:'
                        className={styles['item']}
                    />
                    <Input
                        name='address.city'
                        handleChange={handleChange}
                        label='Город:'
                        className={styles['item']}
                        value={values.address.city}
                    />
                    <Input
                        name='address.street'
                        handleChange={handleChange}
                        label='Улица:'
                        className={styles['item']}
                        value={values.address.street}
                    />
                    <div className={styles['document--group']}>
                        <InputNumbers
                            name='address.zip_code'
                            handleChange={handleChange}
                            label='Индекс:'
                            className={cn(styles['item'], styles['item--address'])}
                            value={values.address.zip_code}
                        /> 
                        <Input
                            name='address.house'
                            handleChange={handleChange}
                            label='Дом:'
                            className={cn(styles['item'], styles['item--address_mr-left'])}
                            value={values.address.house}
                        />
                    </div>
                    <div className={styles['user--group']}>
                        <Input
                            name='address.building'
                            handleChange={handleChange}
                            label='Корпус:'
                            className={cn(styles['item'], styles['item--address'])}
                            value={values.address.building}
                        />
                        <Input
                            name='address.apartment'
                            handleChange={handleChange}
                            label='Квартира:'
                            className={cn(styles['item'], styles['item--address_mr-left'])}
                            value={values.address.apartment}
                        />
                    </div>
                </div>
            </div>
        </GxTabPanel>
    )
}

export default AddressPanel


